import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { AccordionItem, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import type { ParagraphAccordionItem as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphAccordionItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  className?: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphAccordionItem: React.FC<ParagraphAccordionItemProps> = ({ className, entity }) => {
  const paragraph = entity.toJS();

  return (
    <AccordionItem
      className={c('ParagraphAccordionItem', className)}
      title={paragraph.field_title[0].value}
      content={(
        <WysiwygField
          className="px-1"
          html={paragraph.field_body[0].processed}
        />
      )}
    />
  );
};

export default ParagraphAccordionItem;
